import { render, staticRenderFns } from "./FullMotor.vue?vue&type=template&id=1ff3c52e&"
import script from "./FullMotor.vue?vue&type=script&lang=js&"
export * from "./FullMotor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports